import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=85c57520&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts&"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/rich-text-editor.css?vue&type=style&index=0&id=85c57520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c57520",
  null
  
)

export default component.exports